import { createFileRoute } from "@tanstack/react-router";

import { validateAdminSitesSearch } from "../../../../areas/admin/sections/search";
import { AdminSitesPage } from "../../../../areas/admin/sites/AdminSitesPage";

/** Admin sites (FE-14 FR-FE14-05..07): filters in the URL (FE-01 §6.1 `q?`, `state?` and more). */
export const Route = createFileRoute("/app/_seller/admin/sites")({
  validateSearch: validateAdminSitesSearch,
  component: AdminSites,
});

function AdminSites() {
  const search = Route.useSearch();
  return <AdminSitesPage search={search} />;
}
